import React, { Component } from 'react'

class RenderInput  extends Component {
	render() {
		const { input, id, type, disabled, label, placeholder, desc, meta: { touched, error }, className} = this.props

		return(
				<div className={`input-container ${touched && error && 'has-error'}`}>
					<div><label>{label}</label></div>
					<div>
						<input className={className} type={type} {...input} placeholder={placeholder} id={id} disabled={disabled}></input>
						{touched && error && <div><span className="error">{error}</span></div>}
					</div>
				</div>
		)
	}
}


export default RenderInput
